export { CertificationsList, type CertificationsListProps } from './CertificationsList';
